import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { ActivityIndicator } from 'trpc-react-native-ui';
import SubscriptionItem from './SubscriptionItem';

const styles = StyleSheet.create({
  loader: {
    height: 100,
  },
});

type Props = {
  options?: Object[],
  planCharacteristics?: Object,
  nextPlanVouchers?: Object[],
};

// TODO refacto with newOfferOptionsMappedByCreditableServiceSelector when dashboard is available

class SubscriptionDetails extends Component<Props> {
  addEuropeanData = items => {
    const data = items.find(item => item.type === 'DATA');
    if (!data) {
      return items;
    }

    let europeanData = data.characteristics.find(dataType => dataType.name === 'DATA_AND_EUROPE_CREDIT');

    if (europeanData) {
      const formatedEuropeanData = {
        characteristic: {
          value: europeanData.value,
          unit: europeanData.unit,
        },
        name: europeanData.name,
        type: 'DATA',
      };
      return [...items, formatedEuropeanData];
    }

    return items;
  };

  getSubscriptionItems() {
    let subscriptionItems = this.props.options;
    const planCharacteristics = this.props.planCharacteristics;
    const nextPlanVouchers = this.props.nextPlanVouchers;

    if (!planCharacteristics) {
      return null;
    }

    Object.entries(planCharacteristics).forEach(([type, planCharacteristic]) => {
      if (subscriptionItems.some(item => item.type === type)) {
        return;
      }

      subscriptionItems = [
        ...subscriptionItems,
        {
          characteristic: planCharacteristic,
          type: type || 'DEFAULT',
        },
      ];
    });

    subscriptionItems = this.addEuropeanData(subscriptionItems);

    subscriptionItems = subscriptionItems.filter(
      subscriptionItem => Number(subscriptionItem.characteristic?.value) !== 0
    );

    if (nextPlanVouchers && nextPlanVouchers.length > 0) {
      subscriptionItems = subscriptionItems.concat(nextPlanVouchers);
    }

    let voiceBulletPoint, smsBulletPoint, dataBulletPoint, europeDataBulletPoint;
    let roaDataBulletPoint, iddVoiceBulletPoint;

    subscriptionItems = subscriptionItems.filter(item => {
      const itemName = item.name;
      if (!itemName) {
        return false;
      }

      // Roaming checks BEFORE local (more specific first)
      if (itemName.includes('IDD')) {
        iddVoiceBulletPoint = item;
        return false;
      }
      if (itemName.includes('ROA') && itemName.includes('DATA')) {
        roaDataBulletPoint = item;
        return false;
      }

      if (itemName.includes('VOICE')) {
        voiceBulletPoint = item;
        return false;
      }
      if (itemName.includes('SMS')) {
        smsBulletPoint = item;
        return false;
      }
      if (itemName.includes('DATA') && itemName.includes('EUROPE')) {
        europeDataBulletPoint = item;
        return false;
      }
      if (itemName.includes('DATA')) {
        dataBulletPoint = item;
        return false;
      }

      return true;
    });

    return [dataBulletPoint, europeDataBulletPoint, voiceBulletPoint, smsBulletPoint, roaDataBulletPoint, iddVoiceBulletPoint, ...subscriptionItems].filter(
      Boolean
    );
  }

  render() {
    const subscriptionItems = this.getSubscriptionItems();

    if (!subscriptionItems) {
      return <ActivityIndicator style={styles.loader} />;
    }

    return (
      <View>
        {subscriptionItems.map((subscriptionItem, index) => (
          <SubscriptionItem
            key={index}
            type={subscriptionItem.type || 'DEFAULT'}
            name={subscriptionItem.name}
            value={subscriptionItem.characteristic?.value}
            unit={subscriptionItem.characteristic?.unit}
            voucher={subscriptionItem}
          />
        ))}
      </View>
    );
  }
}

export default SubscriptionDetails;
